import { ActionIcon, Divider, Group, Loader, Tooltip } from '@mantine/core';
import { IconTrash, IconRefresh, IconSend, IconTemplate } from '@tabler/icons';
import { FC, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { EmailBoxContext } from '../../Service/Context/EmailBoxContext';
import { MessageS } from '../../Service/MessageS';
import { MessageContext } from '../../Service/Context/MessageContextV2';
import { useEventScope } from '../../Service/hooks/useEventScope';
import { openDeleteEmailsModal } from './MessageModals';

interface Props {
  phoneVersion: boolean;
  loadTemplate: () => void;
}

const EmailFolderActions: FC<Props> = ({ phoneVersion, loadTemplate }) => {
  const { box } = useParams();
  const { isEventScope } = useEventScope();
  const { action, loading: loadingMessage, initMessage } = useContext(MessageContext);
  const { refresh, loading, messages, selectedMessage, pageNumber, setPageNumber, isBookitupScope } =
    useContext(EmailBoxContext);

  const deleteHandler = async () => {
    if (selectedMessage && phoneVersion) {
      if (box === 'trash') {
        const deleted = await MessageS.deleteEmail(selectedMessage.id);
        if (deleted) {
          refresh();
        }
      } else {
        const email = await MessageS.patchEmail(selectedMessage.id, { trash: true });
        if (email) {
          refresh();
        }
      }
    } else {
      removeEmailsHandler();
    }
  };

  const removeEmailsHandler = () =>
    openDeleteEmailsModal({
      ids: messages.map((m) => m.id),
      onDelete: () => {
        if (pageNumber === 0) {
          refresh();
        } else {
          setPageNumber(0);
        }
      },
    });

  if (phoneVersion) return null;

  return (
    <Group
      py={5}
      px="sm"
      spacing="xs"
      sx={(theme) => ({
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
        borderRadius: 25,
      })}
    >
      {!phoneVersion && (
        <>
          {loading && <Loader size="xs" />}
          {!loading && !phoneVersion && (
            <Tooltip openDelay={300} withArrow transition="slide-down" label="Aktualisierung">
              <ActionIcon size="sm" onClick={refresh}>
                <IconRefresh />
              </ActionIcon>
            </Tooltip>
          )}
          {(!action || action !== 'NEW') && <Divider orientation="vertical" />}
          {isEventScope && (
            <>
              <Tooltip openDelay={300} withArrow transition="slide-down" label="Vorlage laden">
                <ActionIcon size="sm" onClick={loadTemplate}>
                  <IconTemplate />
                </ActionIcon>
              </Tooltip>
              <Divider orientation="vertical" />
            </>
          )}
          {action !== 'NEW' && (
            <>
              {loadingMessage && <Loader size="xs" />}
              {!loadingMessage && (
                <Tooltip openDelay={300} withArrow transition="slide-down" label="Neue E-Mail schreiben">
                  <ActionIcon size="sm" onClick={() => initMessage()}>
                    <IconSend />
                  </ActionIcon>
                </Tooltip>
              )}
            </>
          )}
        </>
      )}
    </Group>
  );
};

export default EmailFolderActions;
